export default "__VITE_ASSET__970952c1__"